import { documentHttpContext } from '@/utils/document-http-context';
import axios from 'axios';
import util from '@/script/util';
import { getToken } from '@/script/init';
// import { isiOS } from '@/script/version';
import store from '@/store/index';
import MyLog from '@/script/my-log.js';
import getUserFingerprint from '@/script/user-finger-print.js';
import { Dialog, Toast } from 'vant';

let kycDialogVisible = false;

function normalizeCurrencyDisplay(value) {
  if (value === 'TWD') return '$';
  if (Array.isArray(value)) return value.map(normalizeCurrencyDisplay);
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((result, key) => {
      result[key] = normalizeCurrencyDisplay(value[key]);
      return result;
    }, {});
  }
  return value;
}

function handleKycResponse(data) {
  if (!data || [454, 455, 456].indexOf(data.code) === -1) return;
  if (data.code === 454 && !kycDialogVisible) {
    kycDialogVisible = true;
    Dialog.confirm({ title: '需要身分驗證', message: '付款前需先完成身分驗證。', confirmButtonText: '立即驗證', cancelButtonText: '取消' })
      .then(() => { window.location.hash = '#/kyc'; })
      .catch(() => {})
      .then(() => { kycDialogVisible = false; });
  } else if (data.code === 455) {
    Toast('身分驗證審核中，通過後請重新發起付款');
  } else if (data.code === 456) {
    Toast('身分驗證已鎖定，請聯絡客服');
  }
}

axios.defaults.timeout = 0; // 请求超时时间
const version = window.localStorage.getItem('STORAGE_VERSION');
// const oldVersion = isiOS() ? '1.50.0' : '';
// const oldVersion = '1.49.2';

axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

// axios 请求拦截器
const STORAGE_COMMON_PARAMS = 'STORAGE_COMMON_PARAMS';
const STORAGE_PLATFORM = 'STORAGE_PLATFORM';
const STORAGE_VERSION = 'STORAGE_VERSION';

axios.interceptors.request.use(
  config => {
    const { token, refreshToken } = getToken();
    if (token) {
      config.headers.token = token;
    }
    if (refreshToken) {
      config.headers.refresh_token = refreshToken;
    }
    const platform = localStorage.getItem(STORAGE_PLATFORM);
    if (platform) {
      config.headers.platform = platform;
    }
    const version = localStorage.getItem(STORAGE_VERSION);
    if (version) {
      config.headers.version = version;
    }

    try {
      const commonParams = JSON.parse(
        decodeURIComponent(localStorage.getItem(STORAGE_COMMON_PARAMS))
      );
      if (commonParams) {
        const requestRegion =
          config.region ||
          (config.params && config.params.region) ||
          (config.data && config.data.region);
        if (requestRegion) commonParams.region = requestRegion;
        config.headers.comm_params = encodeURIComponent(
          JSON.stringify(commonParams)
        );
      } else {
        const comm_params = {
          platform: '1',
          region:
            config.region ||
            (config.params && config.params.region) ||
            (config.data && config.data.region) ||
            'TW',
          deviceId: getUserFingerprint()
        };
        config.headers.comm_params = encodeURIComponent(
          JSON.stringify(comm_params)
        );
      }
    } catch (error) {
      console.log(error);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// axios respone拦截器
axios.interceptors.response.use(
  response => {
    const code = response.data && response.data.code;
    const success = response.status === 200 && (code === 200 || code === 0);
    if (success) {
      return Promise.resolve({
        ...response,
        data: normalizeCurrencyDisplay(response.data)
      });
    } else {
      handleKycResponse(response.data);
      const { token } = store.getters;
      if (response.data.code === 423 && !token) {
        return Promise.reject(response);
      } else {
        MyLog.captureException('httpError', {
          tags: {
            httpCode:
              response && response.data && response.data.code
                ? response.data.code
                : 'noCode'
          },
          context: documentHttpContext(response)
        });
        // 暂时屏蔽原生的显示重试按钮
        // util.nativePie('SHOW_RETRY_VIEW', {
        //   request_url: response.config.url,
        //   http_code: response.status,
        //   server_code: '',
        //   server_msg: response.statusText
        // });
        return Promise.reject(response);
      }
    }
  },
  error => {
    const commonParams = localStorage.getItem(STORAGE_COMMON_PARAMS);
    if (!commonParams) return;
    if (Object.prototype.hasOwnProperty.call(error, 'Cancel')) return;
    // if (error.hasOwnProperty('Cancel')) return
    return Promise.reject(error.response || 'Network Error');
  }
);
/**
 * 封装get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function get(url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params, ...config })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function post(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

export { get, post };
